import { type OnrApiMutationOptions, useOnrApi } from './mutation/useOnrApi.ts'

export interface UpdateAssignmentTypeApiVariables {
  regionId: string
  value: 'manual' | 'solver'
}

export const useUpdateAssignmentType = (options?: OnrApiMutationOptions<void, UpdateAssignmentTypeApiVariables>) =>
  useOnrApi<void, UpdateAssignmentTypeApiVariables>({ type: 'updateAssignmentType', ...options })
